import { ca } from '@cian/analytics';

import { IJsonQuery } from '../../../../packages/api-models/common/json_query';
import { TFilterType } from '../../types/filterType';

export function trackClearClick() {
  ca('eventSite', {
    name: 'oldevent',
    action: 'clean_filters',
    category: 'Map',
  });
}

export function trackAdvancedFiltersClick() {
  ca('eventSite', {
    name: 'oldevent',
    action: 'Click',
    category: 'Map',
    label: 'Filters',
  });
}

export function trackApplyClick(queryString?: string) {
  ca('eventSite', {
    name: 'oldevent',
    action: 'button_search',
    label: queryString,
    category: 'Map',
  });
}

interface ITrackFilterFromChipsApplyArgs {
  queryString: string;
  pageType: 'Listing' | 'Map';
  filterType?: TFilterType;
  jsonQuery: IJsonQuery;
}

export const trackFilterFromChipsApply = ({
  queryString,
  pageType,
  jsonQuery,
  filterType,
}: ITrackFilterFromChipsApplyArgs) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'FastFilters',
    action: 'popup_confirm',
    label: queryString,
    page: { pageType, extra: { reason: filterType } },
    sc: jsonQuery,
  });
};
